<ng-container *transloco="let t; read: 'home'">
  <div class="p-grid p-nogutter documents p-jc-center section-margin">
    <div class="p-text-center documents__header">
      <h2 class="home-heading" [innerHTML]="t('documents.header.part1')"></h2>
    </div>
    <div class="p-grid wrapper p-jc-center">
      <div class="p-col-12 p-md-6 p-xl-3">
        <div class="p-shadow-9 documents__tale">
          <p class="textBlue p-text-bold">{{ t('documents.tale.1.header') }}</p>
          <a
            href="assets/downloads/2026/OWU DEFEND Gap 2026.pdf"
            download="OWU DEFEND Gap 2026.pdf">
            <button class="buttonWhite">
              <span class="p-text-bold">{{
                t('documents.tale.1.button')
              }}</span>
            </button>
          </a>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-3">
        <div class="p-shadow-9 documents__tale">
          <p class="textBlue p-text-bold">{{ t('documents.tale.2.header') }}</p>
          <a
            href="assets/downloads/2026/SWU DEFEND Gap MAX 2026.pdf"
            download="SWU DEFEND Gap MAX 2026.pdf">
            <button class="buttonWhite">
              <span class="p-text-bold">{{
                t('documents.tale.2.button')
              }}</span>
            </button>
          </a>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-3">
        <div class="p-shadow-9 documents__tale">
          <p class="textBlue p-text-bold">{{ t('documents.tale.3.header') }}</p>
          <a
            href="assets/downloads/2026/SWU DEFEND Gap MAX AC 2026.pdf"
            download="SWU DEFEND Gap MAX AC 2026.pdf">
            <button class="buttonWhite">
              <span class="p-text-bold">{{
                t('documents.tale.3.button')
              }}</span>
            </button>
          </a>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-3">
        <div class="p-shadow-9 documents__tale">
          <p class="textBlue p-text-bold">{{ t('documents.tale.4.header') }}</p>
          <a
            href="assets/downloads/2026/SWU DEFEND Gap FLEX 2026.pdf"
            download="SWU DEFEND Gap FLEX 2026.pdf">
            <button class="buttonWhite">
              <span class="p-text-bold">{{
                t('documents.tale.4.button')
              }}</span>
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-container>
